import type {
	SuspensionAffectedBooking,
	VehicleSuspension,
} from "../../types/vehicle-suspension.types";
import type {
	SuspensionAffectedBookingDto,
	VehicleSuspensionDto,
} from "@/lib/api";
import { cleanWebApiDateString } from "@/utils/date.utilities";

export function toVehicleSuspension(
	dto: VehicleSuspensionDto
): VehicleSuspension {
	return {
		id: dto.id,
		vehicleId: dto.vehicleId,
		kind: dto.kind,
		reason: dto.reason,
		comment: dto.comment || undefined,
		placedBy: dto.placedBy,
		placedAt: cleanWebApiDateString(dto.placedAt) ?? dto.placedAt,
		changedBy: dto.changedBy ?? undefined,
		changedAt: cleanWebApiDateString(dto.changedAt) ?? undefined,
		liftedBy: dto.liftedBy ?? undefined,
		liftedAt: cleanWebApiDateString(dto.liftedAt) ?? undefined,
		liftReason: dto.liftReason ?? undefined,
		liftComment: dto.liftComment || undefined,
	};
}

export function toSuspensionAffectedBooking(
	dto: SuspensionAffectedBookingDto
): SuspensionAffectedBooking {
	return {
		bookingId: dto.bookingId,
		vehicleId: dto.vehicleId,
		bookerRemoteId: dto.bookerRemoteId,
		status: dto.status,
		start: cleanWebApiDateString(dto.start) ?? dto.start,
		end: cleanWebApiDateString(dto.end) ?? dto.end,
	};
}
